// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"efb0cba7","316":"81a0a802","442":"6f54f5d5","453":"a5d3b9ee","455":"acc864e6","688":"814cabd4","762":"9d2e63b2","977":"bcc922f2"}[chunkId] + ".chunk.js";
};